<div>
  <form [formGroup]="chargeDetailForm">
    <div class="mat-elevation-z8 service-container">
      <mat-table formArrayName="chargeDetails" [dataSource]="chargeDetailsDataSource">
        <ng-container matColumnDef="chargeCode">
          <mat-header-cell *matHeaderCellDef>Charge Code</mat-header-cell>
          <mat-cell *matCellDef="let row;let i=index" [formGroupName]="i">
            <mat-form-field appearance="fill">
              <mat-select (selectionChange)="chargedChanged(row,i)"  formControlName="chargeId" required>
                <mat-option>
                  <ngx-mat-select-search formControlName="chargeSearch" placeholderLabel="Search Charge"
                  noEntriesFoundLabel="No item found" ></ngx-mat-select-search>
                </mat-option>
                <mat-option [value]="null">None</mat-option>
                @for (c of row.get('chargeList').value; track c) {
                  <mat-option [disabled]="checkChargeDisableCondition(c)" [value]="c.parentId" >
                    {{ c.name }} ({{c.code}})
                  </mat-option>
                }
              </mat-select>
              @if (chargeDetails.controls[i].get('chargeId').errors?.required) {
                <mat-error class="mt-1">
                  Required
                </mat-error>
              }
            </mat-form-field>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="chargeName">
          <mat-header-cell *matHeaderCellDef>Charge Name</mat-header-cell>
          <mat-cell *matCellDef="let row; let i=index" [formGroupName]="i">
            <mat-form-field appearance="fill">
              <input matInput formControlName="chargeName" autocomplete="off" readonly>
            </mat-form-field>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="taxable">
          <mat-header-cell *matHeaderCellDef>Taxable</mat-header-cell>
          <mat-cell *matCellDef="let row; let i=index" [formGroupName]="i">
            <mat-form-field appearance="fill">
              <mat-select formControlName="taxable" required>
                @for (t of taxableList; track t) {
                  <mat-option [value]="t.key" >
                    {{ t.label }}
                  </mat-option>
                }
              </mat-select>
              @if (chargeDetails.controls[i].get('taxable').errors?.required) {
                <mat-error class="mt-1">
                  Required
                </mat-error>
              }
            </mat-form-field>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="chargeTypeMechanism">
          <mat-header-cell *matHeaderCellDef>Charge Mechanism</mat-header-cell>
          <mat-cell *matCellDef="let row; let i=index" [formGroupName]="i">
            <mat-form-field appearance="fill">
              <mat-select formControlName="chargeTypeMechanism" required>
                <mat-option [value]="null">None</mat-option>
                @for (d of chargeTypeMechanismList; track d) {
                  <mat-option [value]="d.key" >
                    {{ d.label }}
                  </mat-option>
                }
              </mat-select>
              @if (chargeDetails.controls[i].get('chargeTypeMechanism').errors?.required) {
                <mat-error class="mt-1">
                  Required
                </mat-error>
              }
            </mat-form-field>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="sacCode">
          <mat-header-cell *matHeaderCellDef>SAC Code</mat-header-cell>
          <mat-cell *matCellDef="let row;let i=index" [formGroupName]="i">
            <mat-form-field appearance="fill">
              <mat-select (selectionChange)="sacChanged(row,i)" formControlName="sacId" required>
                <mat-option>
                  <ngx-mat-select-search formControlName="sacSearch" placeholderLabel="Search SAC"
                  noEntriesFoundLabel="No item found" ></ngx-mat-select-search>
                </mat-option>
                <mat-option [value]="null">None</mat-option>
                @for (s of row.get('sacList').value; track s) {
                  <mat-option [value]="s.id" >
                    {{s.code}}
                  </mat-option>
                }
              </mat-select>
              @if (chargeDetails.controls[i].get('sacId').errors?.required) {
                <mat-error class="mt-1">
                  Required
                </mat-error>
              }
            </mat-form-field>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="sacName">
          <mat-header-cell *matHeaderCellDef>SAC Name</mat-header-cell>
          <mat-cell *matCellDef="let row; let i=index" [formGroupName]="i">
            <mat-form-field appearance="fill">
              <input matInput formControlName="sacName" autocomplete="off" readonly>
            </mat-form-field>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="sgst">
          <mat-header-cell *matHeaderCellDef>SGST %</mat-header-cell>
          <mat-cell *matCellDef="let row; let i=index" [formGroupName]="i">
            <mat-form-field appearance="fill">
              <input matInput formControlName="sgst" autocomplete="off" required [readonly]="row.get('id').value">
              @if (chargeDetails.controls[i].get('sgst').errors?.required) {
                <mat-error class="mt-1">
                  Required
                </mat-error>
              }
              @if (chargeDetails.controls[i].get('sgst').errors?.pattern) {
                <mat-error class="mt-1">
                  Enter valid SGST
                </mat-error>
              }
            </mat-form-field>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="cgst">
          <mat-header-cell *matHeaderCellDef>CGST %</mat-header-cell>
          <mat-cell *matCellDef="let row; let i=index" [formGroupName]="i">
            <mat-form-field appearance="fill">
              <input matInput formControlName="cgst" autocomplete="off" required [readonly]="row.get('id').value">
              @if (chargeDetails.controls[i].get('cgst').errors?.required) {
                <mat-error class="mt-1">
                  Required
                </mat-error>
              }
              @if (chargeDetails.controls[i].get('cgst').errors?.pattern) {
                <mat-error class="mt-1">
                  Enter valid CGST
                </mat-error>
              }
            </mat-form-field>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="igst">
          <mat-header-cell *matHeaderCellDef>IGST %</mat-header-cell>
          <mat-cell *matCellDef="let row; let i=index" [formGroupName]="i">
            <mat-form-field appearance="fill">
              <input matInput formControlName="igst" autocomplete="off" required [readonly]="row.get('id').value">
              @if (chargeDetails.controls[i].get('igst').errors?.required) {
                <mat-error class="mt-1">
                  Required
                </mat-error>
              }
              @if (chargeDetails.controls[i].get('igst').errors?.pattern) {
                <mat-error class="mt-1">
                  Enter valid IGST
                </mat-error>
              }
            </mat-form-field>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="gstWef">
          <mat-header-cell *matHeaderCellDef> Gst WEF </mat-header-cell>
          <mat-cell *matCellDef="let row;let i=index" [formGroupName]="i">
            <mat-form-field appearance="fill" style="margin-bottom: 8%;">
              <input (dateChange)="dateChangeEvent($event,row)" matInput [matDatepicker]="picker" formControlName="gstWef" required autocomplete="off" readonly>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              @if (chargeDetails.controls[i].get('gstWef').errors?.required) {
                <mat-error class="mt-1">
                  Required
                </mat-error>
              }
            </mat-form-field>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="deactivated">
          <mat-header-cell *matHeaderCellDef>Deactivated</mat-header-cell>
          <mat-cell *matCellDef="let row; let i=index" [formGroupName]="i">
            @if (row.get('id').value) {
              <mat-checkbox class="ser-icon" (change)="deactivateChanged(row,$event)" formControlName="deactivated"></mat-checkbox>
            }
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="updateGst">
          <mat-header-cell *matHeaderCellDef>Update GST Rates</mat-header-cell>
          <mat-cell class="__action_row" *matCellDef="let row; let i=index">
            @if (!row.get('deactivated').value && row.get('id').value) {
              <span class="__action_edit_icon" (click)="openGstEditForm(row.get('chargeId').value)" style="margin-right: 10px;">
                <mat-icon>create</mat-icon>
              </span>
            }
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="action">
          <mat-header-cell *matHeaderCellDef>Action
            @if (!mandatory && !chargeDetails.length) {
              <button  mat-icon-button (click)="addChargeField()" matTooltip="Add Charge Detail">
                <mat-icon>add_circle</mat-icon>
              </button>
            }
          </mat-header-cell>
          <mat-cell *matCellDef="let row; let i = index;">
            @if (!row.get('id').value) {
              <span class="__action_delete_icon" (click)="removeChargeField(i)" matTooltip="Remove this Charge Detail">
                <mat-icon>delete_forever</mat-icon>
              </span>
            }
            <span style="margin-left: 10px;" class="__action_add_icon" (click)="addChargeField(row)" matTooltip="Add Charge Detail">
              <mat-icon mat-cell>add_circle</mat-icon>
            </span>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="chargeDetailColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: chargeDetailColumns" [class.hidden]="!row.get('show').value"></mat-row>
      </mat-table>
    </div>
  </form>
</div>
